module.exports = __webpack_public_path__ + "search-icon-white.svg?cc388dc04fc228f85fa0a91d18258f91";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/search-icon-white.svg
// module id = 648
// module chunks = 0